import { saveFilterInheritValues } from '@intelligence/v3/_hooks/useFilterablePage/utils/filterInherit';

import type { IFilterItemConfig, IFilterValues } from '@intelligence/v3/filterCore/types';

/**
 * Demo 跳转入口。
 * 跳转前保存当前 draft 中可继承字段，让目标页通过 inheritSource 初始化。
 */
export const navigateWithDraftInheritance = (params: {
  pageId: string;
  items: IFilterItemConfig[];
  draftValues: IFilterValues;
  dispatch: Function;
  navigate: () => void;
}): void => {
  const { pageId, items, draftValues, dispatch, navigate } = params;

  saveFilterInheritValues(pageId, items, draftValues, dispatch);
  navigate();
};
